export default "__VITE_ASSET__Cz2S7TL0__"